import {
  WSButton,
  WSCard,
  WSFlexBox,
  WSIcon,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

export interface PrereqGateBlocker {
  /** Stable identity of the blocking form (e.g. its catalog formId). */
  key: string;
  /** Human title; falls back to `key` when the host can't resolve one. */
  title?: string;
  /** Host navigation to the blocking form; row renders as plain text when absent. */
  onOpen?: () => void;
}

type Props = {
  blockers: PrereqGateBlocker[];
  formTitle?: string;
};

// Locked-form gate: shown in place of the form (and everything else) when
// prerequisites are outstanding. Lists every blocking form with a clock icon
// and — when the host supplies navigation — a link to open it, matching the
// "Pre-requisite gate" in the form anatomy. Purely presentational: the host
// resolves blocker titles/navigation (e.g. from its checklist) and passes them
// in, so the gate has no knowledge of any particular domain's data layer.
export const DynamicFormPrereqGate: React.FC<Props> = ({
  blockers,
  formTitle
}) => (
  <WSCard>
    <WSList gap="L">
      <WSList gap="XS">
        <WSFlexBox.CenterY gap="S" wrap="nowrap">
          <WSIcon name="lock" size="M" color="gray500" />
          <WSText.Heading5 color="gray700">
            {formTitle ? `${formTitle} is locked` : "This form is locked"}
          </WSText.Heading5>
        </WSFlexBox.CenterY>
        <WSText.ParagraphSm color="gray600">
          Complete all pre-requisite forms to unlock this form.
        </WSText.ParagraphSm>
      </WSList>
      <WSList gap="S">
        {blockers.map(blocker => (
          <WSFlexBox.CenterY key={blocker.key} gap="S" wrap="nowrap">
            <WSIcon name="time" size="S" color="gray500" />
            {blocker.onOpen ? (
              <WSButton kind="Link" onClick={blocker.onOpen}>
                {blocker.title ?? blocker.key}
              </WSButton>
            ) : (
              <WSText.ParagraphSm color="gray600">
                {blocker.title ?? blocker.key}
              </WSText.ParagraphSm>
            )}
          </WSFlexBox.CenterY>
        ))}
      </WSList>
    </WSList>
  </WSCard>
);
